<template>
  <div class="table-responsive">
    <DataTable
:key="columns.length"
      class="display table table-bordered table-sm text-sm" :data="filteredData" :columns="columns"
      :options="{ paging: false }" />
  </div>
</template>
<script>
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
DataTable.use(DataTablesCore);

const hoursFormatter = new Intl.NumberFormat(navigator.languages, {minimumFractionDigits: 2, maximumFractionDigits: 2})

export default {
  name: 'AccountsTable',
  components: {
    DataTable
  },
  props: {
    users: {
      type: Map,
      required: true
    },
    timelogs: {
      type: Array,
      required: true
    },
    userIdsFilter: {
      type: Set,
      required: true
    }
  },
  computed: {
    columns() {
      const distinctAccounts = new Set(this.timelogs.map((t) => t._task?._account))
      distinctAccounts.delete(undefined)
      const accounts = distinctAccounts.values().toArray().sort()

      return [
        {
          title: 'User Name',
          data: 'userId',
          defaultContent: '(Unknown)',
          render: (data) => this.users.get(data)
        },
        ...accounts.map((a) => ({
          title: a,
          data: a.replaceAll('.', '\\.'), //plain dots represent nested objects for Datatables.net so we need to escape these
          render: (data) => data ? hoursFormatter.format(data) : '',
          footer: hoursFormatter.format(
              this.timelogs.filter(
                (t) => t._task?._account === a
              ).reduce(
                (total, t) => total + t.hours,
                0 //initial value
              )
            )
        }))
      ]
    },
    data() {
      const usersAccountTotals = new Map()
      for (const t of this.timelogs) {
        if (!usersAccountTotals.has(t.userId)) {
          usersAccountTotals.set(t.userId, { userId: t.userId })
        }
        const user = usersAccountTotals.get(t.userId)
        const accountKey = t._task?._account
        if (accountKey !== undefined) {
          user[t._task._account] = (user[t._task._account] ?? 0) + t.hours
          user.total = (user.total ?? 0) + t.hours
        }
      }
      return usersAccountTotals.values().toArray()
    },
    filteredData() {
      return this.data.filter((e) => this.userIdsFilter.has(e.userId))
    }
  }
}
</script>
<style>
@import 'datatables.net-bs5';
</style>